var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgEllipsis = function SvgEllipsis(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 8.75C6.56641 8.75 5.9375 8.12109 5.9375 7.34375C5.9375 6.56641 6.56641 5.9375 7.34375 5.9375C8.12109 5.9375 8.75 6.56641 8.75 7.34375C8.75 8.12109 8.12109 8.75 7.34375 8.75ZM8.75 10.7813C8.75 10.0039 8.12109 9.375 7.34375 9.375C6.56641 9.375 5.9375 10.0039 5.9375 10.7813C5.9375 11.5586 6.56641 12.1875 7.34375 12.1875C8.12109 12.1875 8.75 11.5586 8.75 10.7813ZM8.75 3.90625C8.75 3.12891 8.12109 2.5 7.34375 2.5C6.56641 2.5 5.9375 3.12891 5.9375 3.90625C5.9375 4.68359 6.56641 5.3125 7.34375 5.3125C8.12109 5.3125 8.75 4.68359 8.75 3.90625Z",
    fill: "#A2A0B4"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEllipsis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ellipsis.12a32645.svg";
export { ForwardRef as ReactComponent };